import { writable } from 'svelte/store';

// Standalone module so Auth.js and access.js can both import `currentUser`
// without a circular dep.
export const currentUser = writable(null);

// tap-db user doc ({redeemedCodes, ...}) — kept in a store (not on the auth
// user object) so the codes table refreshes after an in-app redemption.
export const tapUser = writable(null);

// Shared by every "Redeem a code" entry point (rail, account panel, empty
// state, access card) and the modal itself.
export const redeemModalOpen = writable(false);
